import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface AuthState {
  token: string | null;
  islogin?: boolean;
  isAuthenticated: boolean;
  userType: number; // aDMIN OR cLIENT
}

const initialState: AuthState = {
  token: localStorage.getItem("token"),
  islogin: localStorage.getItem("isAuthenticated") === "false",
  isAuthenticated: localStorage.getItem("isAuthenticated") === "false",
  userType: 565,
};

const AuthReducer = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setLoginState(state, action: PayloadAction<any>) {
      state.islogin = action.payload.status;
      state.isAuthenticated = action.payload.status;
      localStorage.setItem("isAuthenticated", String(action.payload.status));
    },
    setToken(state, action: PayloadAction<any>) {
      state.token = action.payload;
      if (action.payload) {
        localStorage.setItem("token", action.payload);
      } else {
        localStorage.removeItem("token");
      }
    },
    setAuthenticated(state, action: PayloadAction<any>) {
      state.isAuthenticated = action.payload;
      localStorage.setItem("isAuthenticated", String(action.payload));
    },
    setUserType(state, action: PayloadAction<{ userType: number }>) {
      state.userType = action.payload.userType;
      localStorage.setItem("userType", String(action.payload.userType));
    },
  },
});

export const { setLoginState, setToken, setAuthenticated, setUserType } =
  AuthReducer.actions;

export default AuthReducer.reducer;
